import React, { useState, useEffect, useContext,  useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import FileUploadTable from "components/Content/CustomTable/FileUploadTable";
import { Button } from "@mui/material";
import ButtonStyle from "components/Button/ButtonStyle.module.css";

import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";

import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";

import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import FileUploadsDialog from "components/Content/Modal/FileUploadsDialog";

function Uploads(props) {
  const { modalIsOpen, setModalIsOpen, companyId, setCompany, error } = useContext(PrivateRoutesContext);
  const [openModal, setOpen] = useState(false);  
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // FILE UPLOAD START
  useEffect(() => {
    let selectedCompany = localStorage.getItem(`selectedBrokerCompanyId`);
    console.log(`current company ${selectedCompany}`)
    if (selectedCompany == null || selectedCompany === "") {
      setModalIsOpen(true)
    }
    else {
      setCompany(selectedCompany, "Broker")
    }
    getUserUploads();
  }, [companyId]);

  const getUserUploads = () => {
    setIsLoading(true);

    let selectedCompany = localStorage.getItem(`selectedBrokerCompanyId`);
    apiGet(apiUrls.getUserUploads(selectedCompany)).then(
      (response) => {
        setFetchedData(response.data);
        setIsLoading(false);
      }
    ).catch(
      (response) => {
        error.setTitle("An Error Occurred");
        error.setText("An Error occurred loading the files.");
        error.setDoShowError(true);
        setIsLoading(false);
      }
    );
  }

  return (
    <div>
      <div className={TableStyle.tableWrapper}>
        <FileUploadTable 
          uploadFiles={fetchedData}
          isLoading={isLoading}
          doDisplayErrorToggle={false}
          headerContents={<Button
            variant="outlined"
            color="primary"
            className={ButtonStyle.CsubmitBtn}
            onClick={() => setOpen(true)}
            startIcon={<PublishOutlinedIcon />}
          >
            Upload File
          </Button>}
        />

        {/* FILE UPLOAD MODAL */}
        <FileUploadsDialog openModal={openModal} handleClose={() => setOpen(false)} getUserUploads={getUserUploads} />
      </div>
    </div>
  );
}

export default Uploads;
